import { IcArrowTriangle, IcArrowTriangleFilled } from '@assets/icons/24x24';
import { Button, Icon, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';

export interface MenuSubItemProps {
  label: string | ReactElement;
  isSelected: boolean;
  onClick: () => void;
  onHover: () => void;
  isDisabled?: boolean;
  isActive?: boolean;
  hasChildren?: boolean;
  isLoading?: boolean;
  depth: number;
}

export function MenuSubItem({
  label,
  isSelected,
  onClick,
  onHover,
  isActive = false,
  isDisabled = false,
  hasChildren = false,
  isLoading = false,
  depth,
}: Readonly<MenuSubItemProps>) {
  return (
    <Button
      variant="contextMenu"
      disabled={isDisabled}
      data-has-solid-bg={depth > 1}
      data-active={isActive}
      data-selected={isSelected}
      onClick={onClick}
      onMouseEnter={onHover}
      justifyContent="space-between"
      loading={isLoading}
    >
      {typeof label === 'string' ? <Text>{label}</Text> : label}
      {hasChildren && (
        <Icon
          as={isSelected ? IcArrowTriangleFilled : IcArrowTriangle}
          transform={isSelected ? 'rotate(-90deg)' : undefined}
          boxSize="24px"
          marginLeft={2}
        />
      )}
    </Button>
  );
}
